import { Directive, effect, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[appScrollToId]',
  standalone: true,
})
export class ScrollToIdDirective {
  private readonly elementRef = inject(ElementRef);

  public readonly appScrollToId = input.required<string | null | undefined>();

  constructor() {
    effect(() => {
      const id = this.appScrollToId();
      if (id) {
        this.scrollToElement(id);
      }
    });
  }

  private scrollToElement(id: string): void {
    const element = document.getElementById(id);
    if (element) {
      this.scrollIntoParentView(element, this.elementRef.nativeElement);
    }
  }

  private scrollIntoParentView(child: HTMLElement, scrollableParent: HTMLElement): void {
    const childRect = child.getBoundingClientRect();
    const parentRect = scrollableParent.getBoundingClientRect();

    const offsetTop = childRect.top - parentRect.top + scrollableParent.scrollTop;
    const offsetLeft = childRect.left - parentRect.left + scrollableParent.scrollLeft;

    // Center the element horizontally within the scrollable parent
    const centeredLeft = offsetLeft - (scrollableParent.offsetWidth - child.offsetWidth) / 2;

    scrollableParent.scrollTo({
      top: offsetTop,
      left: centeredLeft,
      behavior: 'smooth',
    });
  }
}
